import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

export type GetRoleActionsRequest = {
  roleId?: number;
};

export type IRoleActionItem = {
  id: number;
  roleId: number;
  roleName: string;
  microServiceName: string;
  controllerName: string;
  actionName: string;
  canCall: boolean;
  status: string | null;
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: null | string;
  updateUserId: number;
  deleteDate: null | string;
  deleteUserId: number;
};

export type GetRoleActionsResponse = {
  isSuccess: boolean;
  message: string;
  data: Array<IRoleActionItem>;
};

async function getRoleActions(
  data: GetRoleActionsRequest
): Promise<GetRoleActionsResponse> {
  try {
    const params = data.roleId ? `?roleId=${data.roleId}` : '';
    return (await axiosInstance.get(`/RoleAction/GetRoleActions${params}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetRoleActions() {
  return useMutation<GetRoleActionsResponse, Error, GetRoleActionsRequest>(
    (variables) => getRoleActions(variables)
  );
}